import { useEffect } from "react";

const FAVICON_DEFAULT = "/favicon.ico";
const FAVICON_NOTIFICATION = "/favicon-notification.ico";

export function useFaviconBadge(hasUnread: boolean) {
    useEffect(() => {
        try {
            const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
            if (!link) return;

            link.href = hasUnread ? FAVICON_NOTIFICATION : FAVICON_DEFAULT;

            return () => {
                try {
                    link.href = FAVICON_DEFAULT;
                } catch {}
            };
        } catch {}
    }, [hasUnread]);
}
